import React, { Suspense } from 'react';
import { imRender } from '@/common/utils/react';
import { assignBlankGlobalImObject } from './common/core/blankGlobalImObject';

// Инициализация глобальной переменной, через которую обеспечивается возможность регистрации внешних плагинов
assignBlankGlobalImObject();

const ApplicationContainer = React.lazy(() => import('./app'));

const root = document.createElement('div');
root.id = 'root';

document.body.appendChild(root);

imRender(
    <Suspense fallback="Загрузка....">
        <ApplicationContainer />
    </Suspense>,
    document.getElementById('root')
);
